module.exports = __webpack_public_path__ + "static/grafia-d85f92743f5605485c2c9f0742495281.svg";